export const RECEIVE_WIKI_COURSES = 'RECEIVE_WIKI_COURSES';
export const SORT_WIKI_COURSES = 'SORT_WIKI_COURSES';
